// Same number and label as the drop page's DropWhatsappButton, so the two
// surfaces stay in sync.
export const NEWSLETTER_WHATSAPP_LINK = 'https://wa.me/447761831807';
export const NEWSLETTER_WHATSAPP_TEXT = 'Chat on WhatsApp';

// WhatsApp brand green, matching DropWhatsappButton's resting state.
export const NEWSLETTER_WHATSAPP_COLOR = '#18D842';

// White glyph on transparent, rasterised from the WhatsappIcon SVG component —
// email clients strip inline SVG, so the icon has to be a hosted bitmap. Served
// at 24px from a 48px source so it stays sharp on retina. The button's label is
// real text, so a blocked or missing image only costs the glyph, never the CTA.
// Lives alongside the footer's social icons, so it resolves off the same domain.
export const getNewsletterWhatsappIcon = (domain: string) =>
	`${domain}/img-svelte/icons/heni_whatsapp_icon.png`;
export const NEWSLETTER_WHATSAPP_ICON_SIZE = 26;
